import { render, staticRenderFns } from "./SubmitSupportTicketModal.vue?vue&type=template&id=50fe4256&"
import script from "./SubmitSupportTicketModal.vue?vue&type=script&lang=js&"
export * from "./SubmitSupportTicketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports